/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.2 routes of Tshmanager::Application.
 * @version c218e81499efdd91ae1a399d08154edb3906c09285906d6b7679419fc7a5530e
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /active_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/active-tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_tags_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"active-tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addresses_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_chat"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/building_complex(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"building_complex"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/building_complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"building_complexes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/person(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_person_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"person"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/task(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/task_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_task_comment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"task_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/task_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_task_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"task_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/tasks/creator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_tasks_creator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"creator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/tasks/dates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_tasks_dates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apis/mcp/tasks/responsible(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apis_mcp_tasks_responsible_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apis"],[2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"responsible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /area_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const area_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /area_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const area_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/avatar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const avatar_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aws_action_mailbox_ses_engine_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/billing_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_packages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_packages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/breadcrumbs_buttons/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const breadcrumbs_buttons_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"breadcrumbs_buttons"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_children_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_properties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_areas_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_buildings_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_contracts_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/bc/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_destroy_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit/bc/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_edit_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_events_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_policies_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_meters_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/bc/:building_complex_id/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_new_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/bc/:building_complex_id/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_search_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_services_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/bc/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/bc/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/bc/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_update_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bc"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_warranties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tenants/:id/change_current(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_current_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /confirmations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /emails/:id/content(/:collapsetype)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"collapsetype":{},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"content"],[2,[1,[2,[7,"/"],[3,"collapsetype"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/coordinates(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coordinates_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_sessions/destroy_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_all_active_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /downloads/:signed_id(.:format)
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"downloads"],[2,[7,"/"],[2,[3,"signed_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /area_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_area_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_packages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit_comment/:comment_id(.:format)
 * @param {any} id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_comment"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirmations/:confirmation_token/edit(.:format)
 * @param {any} confirmation_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_confirmation_path = /*#__PURE__*/ __jsr.r({"confirmation_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[2,[7,"/"],[2,[3,"confirmation_token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_flowchart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /passwords/:password_reset_token/edit(.:format)
 * @param {any} password_reset_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_path = /*#__PURE__*/ __jsr.r({"password_reset_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"password_reset_token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /property_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_task_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/delete(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_delete_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/download(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_download_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /file_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/move(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_move_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/pdf_viewer(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_pdf_viewer_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"pdf_viewer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/preview(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_preview_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/preview_status(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_preview_status_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/title(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_title_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"title"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/:id/files/:record_type/:record_id(.:format)
 * @param {any} id
 * @param {any} record_type
 * @param {any} record_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_file_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"record_type":{"r":true},"record_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"record_type"],[2,[7,"/"],[2,[3,"record_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flowchart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flowcharts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /emails/:id/forward(/:mailbox_id)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forward_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"mailbox_id":{},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"forward"],[2,[1,[2,[7,"/"],[3,"mailbox_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /globalsearch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const globalsearch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"globalsearch"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /go/area/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_area_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/building/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_building_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"building"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/building_complex/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"building_complex"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/company/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/contract/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/email/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/insurance_event/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_insurance_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"insurance_event"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/insurance_policy/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_insurance_policy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"insurance_policy"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/meter/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_meter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"meter"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/person/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"person"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/person_group/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"person_group"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/property/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/service/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"service"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/task/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/taskcomment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_taskcomment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"taskcomment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/warranty/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_warranty_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"warranty"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /guard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guard_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /emails/massupdate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const massupdate_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"massupdate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mentions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"jobs"]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_discards_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_retries_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_discard_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_dispatch_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_retry_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/:status/jobs(.:format)
 * @param {any} application_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_jobs_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} application_id
 * @param {any} queue_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_pause_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queues_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_task_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_tasks_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_worker_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_workers_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_jobs_path = /*#__PURE__*/ __jsr.r({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queue_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"jobs"]],[7,"/"]]);

/**
 * Generates rails route to
 * /area_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_area_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_billing_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_packages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_billing_package_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_packages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/child(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_child_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"child"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confirmations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_flowchart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/fromemail/:emailid(.:format)
 * @param {any} emailid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fromemail_tasks_path = /*#__PURE__*/ __jsr.r({"emailid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"fromemail"],[2,[7,"/"],[2,[3,"emailid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mailbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_newsletter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /passwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_person_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_person_group_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_property_relationship_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_property_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/new(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_subscriber_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /task_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_tenant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passwords/:password_reset_token(.:format)
 * @param {any} password_reset_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_path = /*#__PURE__*/ __jsr.r({"password_reset_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"password_reset_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwords_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /people/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /postcode/hu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postcode_hu_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postcode"],[2,[7,"/"],[2,[6,"hu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /postcode/hu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postcode_hu_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postcode"],[2,[7,"/"],[2,[6,"hu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/postmortem(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postmortem_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"postmortem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /property_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_service_worker_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/ses/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_ses_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/record(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const record_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/reply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_api_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * /api-docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rswag_ui_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"api-docs"]]);

/**
 * Generates rails route to
 * /area_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_area_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_items/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_billing_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_items"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_packages/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_billing_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_packages"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_building_area_properties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_building_areas_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_buildings_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_contracts_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_insurance_events_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_insurance_policies_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_meters_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_services_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_warranties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_company_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_flowcharts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_person_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_checkpoints_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/search(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_road_patrols_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_roads_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_subscribers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_task_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_checkpoints_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_patrols_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_roads_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/update_serial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_update_serial_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"update_serial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/show-multiple-actions-toolbar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_multiple_actions_toolbar_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"show-multiple-actions-toolbar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/show-original-actions-toolbar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_original_actions_toolbar_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"show-original-actions-toolbar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ms/*filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_content_path = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{},"host":{"d":"tshm.hu"}}, [2,[7,"/"],[2,[6,"ms"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/signature/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signature"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/signature_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_upload_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"signature_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /static_pages/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_pages_home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"static_pages"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /task_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_id/task_schedules/:id(.:format)
 * @param {any} task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_task_schedule_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"task_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /task_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/update_comment/:comment_id(.:format)
 * @param {any} id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_comment"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/upload_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_files_file_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[6,"upload_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /userinfo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userinfo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

